import React, { useContext } from "react";

// React Router Dom
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

// components
import Console from "./components/console/Console";
import StartPage from "./components/startpage/StartPage";
import HelpfulMessage from "./components/console/HelpfulMessage";
import UpdateWeaviatePage from "./components/console/UpdateWeaviatePage";

import { StateContext, StateDispatchContext } from "./AppStateContext";
import { wcsLogin } from "./helperFunctions";

const Routes = () => {
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  const getOidcLoginURL = () => {
    let responseType = "code"
    if (state.selfHostedOidcUri && state.selfHostedOidcUri.startsWith("https://login.microsoftonline.com")) {
      responseType = encodeURI(`code id_token`)
    }
    var url = `${state.selfHostedOidcUri}?client_id=${state.clientId}&response_mode=fragment&response_type=${responseType}&redirect_uri=${window.origin}/console/home`
    if (state.selfHostedOidcScopes) {
      const scopes = encodeURI(state.selfHostedOidcScopes.join(' '))
      url = `${url}&scope=${scopes}&nonce=abcde`
    }
    return url
  }
  const getOidcLogoutURL = () => {
    if (state.oidcConfiguration) {
      var url = `${state.oidcConfiguration.logout}?client_id=${state.clientId}&response_mode=fragment&response_type=code&redirect_uri=${window.origin}`
      if (state.selfHostedOidcScopes) {
        const scopes = encodeURI(state.selfHostedOidcScopes.join(' '))
        url = `${url}&scope=${scopes}`
      }
      return url
    } else {
      return `${state.oidcUri}protocol/openid-connect/logout?client_id=${state.clientId}&response_mode=fragment&response_type=code&redirect_uri=${window.origin}`
    }
  }
  return (
    <Router>
      <Switch>
        {/* handles self hosted authenticated Weaviate instances */}
        <Route
          path="/oidclogin"
          render={() =>
            ( window.location = getOidcLoginURL() )
          }
        />
        {/* To register to a new WCS account */}
        <Route
          path="/wcsregister"
          render={() =>
            (window.location = `${state.oidcUri}protocol/openid-connect/registrations?client_id=wcs&response_type=code&redirect_uri=${window.origin}`)
          }
        />
        <Route
          path="/update-weaviate-version"
          render={() => <UpdateWeaviatePage />}
        />
        {/* Toggle between modules */}
        <Route path="/console/:module" component={Console} />
        {/* Logs out user and goes back to start page */}
        <Route
          path="/logout"
          render={() =>
            (window.location = getOidcLogoutURL() )
          }
        />
        <Route
          path="/registration-login"
          render={() => {
            setTimeout(() => wcsLogin(setState, state), 0);
          }}
        />
        <Route
          path="console/:module/info-page"
          render={() => <HelpfulMessage />}
        />
        <Route exact path="/" component={StartPage} />
      </Switch>
    </Router>
  );
};

export default Routes;
